import {Component, ChangeDetectorRef, Inject} from '@angular/core';
import {AuthService} from '../auth/services/auth-service';
import {AuthenticatedResult} from "angular-auth-oidc-client";
import {Observable} from "rxjs";

@Component({
  selector: 'footer-component',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent  {
    currentYear = 0;
    isAuthenticated$: Observable<AuthenticatedResult>;

    constructor(private ref: ChangeDetectorRef,
                protected readonly authService: AuthService) {
        this.currentYear = (new Date()).getFullYear();
        this.isAuthenticated$ = authService.isAuthenticated();
    }
}
